<template>
  <div class="customer-point-container">
    <!-- 积分概览卡片 -->
    <el-card class="point-overview-card" shadow="never" style="margin-bottom: 20px;">
      <div slot="header" class="clearfix">
        <span>积分概览</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="overview-item">
            <div class="label">总积分</div>
            <div class="value total">{{ pointDetail.totalPoint || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="overview-item">
            <div class="label">锁定积分</div>
            <div class="value locked">{{ pointDetail.lockedPoint || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="overview-item">
            <div class="label">当前有效可兑换</div>
            <div class="value effective">{{ pointDetail.effectiveRedeemablePoint || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="overview-item">
            <div class="label">已兑换积分</div>
            <div class="value redeemed">{{ pointDetail.redeemedPoint || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6" style="margin-top: 20px;">
          <div class="overview-item">
            <div class="label">可兑换积分 (含过期)</div>
            <div class="value">{{ pointDetail.redeemablePoint || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6" style="margin-top: 20px;">
          <div class="overview-item">
            <div class="label">禁用积分</div>
            <div class="value disabled">{{ pointDetail.disabledPoint || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="6" style="margin-top: 20px;">
          <div class="overview-item">
            <div class="label">已过期积分</div>
            <div class="value expired">{{ pointDetail.expiredPoint || 0 }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 筛选表单 -->
    <el-form :inline="true" :model="queryForm" class="point-query-form" size="mini">
      <el-form-item label="时间范围">
        <el-date-picker
          v-model="queryForm.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleFilter">
        </el-date-picker>
      </el-form-item>
      
      <!-- 视需要添加状态下拉筛选
      <el-form-item label="状态">
        <el-select v-model="queryForm.status" placeholder="全部" clearable @change="handleFilter">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      -->
      
      <!-- 视需要添加来源类型下拉筛选
      <el-form-item label="来源类型">
        <el-select v-model="queryForm.sourceType" placeholder="全部" clearable @change="handleFilter">
          <el-option
            v-for="item in sourceTypeList"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      -->

      <el-form-item>
        <el-button type="primary" @click="handleFilter" icon="el-icon-search">查询</el-button>
        <el-button @click="resetQuery" icon="el-icon-refresh">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 日志明细表格 -->
    <el-table border :data="logList" size="mini" v-loading="loading" style="width: 100%">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="point" label="积分变动" width="120">
        <template slot-scope="scope">
          <span :class="scope.row.point >= 0 ? 'color-success' : 'color-danger'">
            {{ scope.row.point > 0 ? '+' + scope.row.point : scope.row.point }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="sourceTypeName" label="来源类型" width="120"></el-table-column>
      <el-table-column prop="source" label="来源单号/ID" width="180"></el-table-column>
      <el-table-column prop="statusName" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)" size="mini">
            {{ scope.row.statusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="变动时间" width="160"></el-table-column>
      <el-table-column prop="beginTime" label="生效时间" width="160"></el-table-column>
      <el-table-column prop="endTime" label="过期时间" width="160"></el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination-container" style="margin-top: 15px; text-align: right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customerPoint',
  props: {
    customerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      pointDetail: {},
      logList: [],
      // statusList: [],
      // sourceTypeList: [],
      queryForm: {
        dateRange: [],
        // status: '',
        // sourceType: ''
      },
      page: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  watch: {
    customerId: {
      handler(newVal) {
        if (newVal) {
          this.initData();
        }
      },
      immediate: true
    }
  },
  created() {
    // this.fetchStatusList();
    // this.fetchSourceTypeList();
  },
  methods: {
    initData() {
      this.fetchPointDetail();
      this.fetchLogList();
    },
    // 获取积分概览
    fetchPointDetail() {
      if (!this.customerId) return;
      this.$apiGet('lechun-cms/customerPoint/getDetail', { customerId: this.customerId })
        .then(res => {
          if (res) {
            this.pointDetail = res || {};
          }
        })
        .catch(err => {
          console.error("Failed to fetch point detail:", err);
        });
    },
    // 获取积分流水
    fetchLogList() {
      if (!this.customerId) return;
      this.loading = true;
      
      let params = {
        customerId: this.customerId,
        currentPage: this.page.currentPage,
        pageSize: this.page.pageSize
      };

      if (this.queryForm.dateRange && this.queryForm.dateRange.length === 2) {
        params.startTime = this.queryForm.dateRange[0];
        params.endTime = this.queryForm.dateRange[1];
      }
      
      // if (this.queryForm.status !== '') {
      //   params.status = this.queryForm.status;
      // }
      // if (this.queryForm.sourceType !== '') {
      //   params.sourceType = this.queryForm.sourceType;
      // }

      this.$apiGet('lechun-cms/customerPoint/getLogList', params)
        .then(res => {
          this.loading = false;
          if (res) {
            this.logList = res.list || [];
            this.page.total = res.total || 0;
            this.page.currentPage = res.currentPage || 1;
          }
        })
        .catch(err => {
          this.loading = false;
          console.error("Failed to fetch log list:", err);
        });
    },
    // 获取状态枚举 (留作扩展)
    // fetchStatusList() {
    //   this.$apiGet('lechun-cms/customerPoint/getStatusList').then(res => {
    //     this.statusList = res || [];
    //   });
    // },
    // 获取来源类型枚举 (留作扩展)
    // fetchSourceTypeList() {
    //   this.$apiGet('lechun-cms/customerPoint/getSourceTypeList').then(res => {
    //     this.sourceTypeList = res || [];
    //   });
    // },
    
    // 搜索过滤
    handleFilter() {
      this.page.currentPage = 1;
      this.fetchLogList();
    },
    // 重置搜索
    resetQuery() {
      this.queryForm.dateRange = [];
      // this.queryForm.status = '';
      // this.queryForm.sourceType = '';
      this.handleFilter();
    },
    // 分页大小变化
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.fetchLogList();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchLogList();
    },
    
    // UI Helper: 根据状态返回不同颜色的 Tag
    getStatusTagType(status) {
      const map = {
        0: 'warning', // 锁定
        1: 'success', // 可兑换
        2: 'info',    // 已兑换
        3: 'danger',  // 禁用
        4: 'info'     // 过期 (自定义或前端判断等)
      };
      return map[status] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-point-container {
  .point-overview-card {
    .overview-item {
      text-align: center;
      padding: 10px 0;
      background-color: #f8f9fa;
      border-radius: 4px;
      
      .label {
        font-size: 13px;
        color: #606266;
        margin-bottom: 8px;
      }
      
      .value {
        font-size: 20px;
        font-weight: bold;
        color: #303133;
        
        &.total { color: #409EFF; }
        &.effective { color: #67C23A; }
        &.locked { color: #E6A23C; }
        &.redeemed { color: #909399; }
        &.danger, &.expired { color: #F56C6C; }
      }
    }
  }
  
  .color-success {
    color: #67C23A;
    font-weight: bold;
  }
  
  .color-danger {
    color: #F56C6C;
    font-weight: bold;
  }
}
</style>
